module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bubble-logo-134870c14d2a9a8277ae6d0cb6256e0e.svg";